import { List } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 0;
  background-color: #fff;
`;

export const CategorySection = styled.section`
  margin-bottom: 32px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const CategoryTitle = styled.h3`
  font-size: 14px;
  font-weight: 700;
  color: #000;
  margin-bottom: 16px;
  line-height: 22px;
`;

export const ItemMeta = styled(List.Item.Meta)`
  align-items: center;
  .ant-list-item-meta-avatar {
    margin-right: 8px;
    margin-left: 16px;
  }
`;

export const EmptyWrapper = styled.div`
  padding: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;

  button {
    margin-top: 16px;
  }
`;
